import React from 'react';

const STATUS_CONFIG = {
  empty: {
    label: '빈 테이블',
    dotClass: 'gray',
    badgeClass: 'badge-empty',
    textColor: 'var(--text-tertiary)',
  },
  occupied: {
    label: '사용 중',
    dotClass: 'green',
    badgeClass: 'badge-occupied',
    textColor: 'var(--primary)',
  },
  payment_pending: {
    label: '결제 중',
    dotClass: 'yellow',
    badgeClass: 'badge-payment_pending',
    textColor: 'var(--warning)',
  },
  payment_done: {
    label: '결제 완료',
    dotClass: 'blue',
    badgeClass: 'badge-payment_done',
    textColor: 'var(--success)',
  },
};

const formatWon = (amount) => {
  if (!amount && amount !== 0) return '';
  return `₩${Number(amount).toLocaleString('ko-KR')}`;
};

const getElapsed = (startTime) => {
  if (!startTime) return null;
  const start = new Date(startTime);
  const now = new Date();
  const diffMs = now - start;
  const diffMin = Math.floor(diffMs / 60000);
  if (diffMin < 60) return `${diffMin}분`;
  const h = Math.floor(diffMin / 60);
  const m = diffMin % 60;
  return `${h}시간 ${m}분`;
};

const TableCard = ({ table, onQRClick, onReset, onDelete, onPaymentComplete, onClick }) => {
  const status = table.status || 'empty';
  const config = STATUS_CONFIG[status] || STATUS_CONFIG.empty;
  const elapsed = getElapsed(table.occupiedAt || table.occupied_at);

  const handleReset = (e) => {
    e.stopPropagation();
    if (onReset) onReset(table);
  };

  const handleDelete = (e) => {
    e.stopPropagation();
    if (onDelete) onDelete(table);
  };

  const handleQR = (e) => {
    e.stopPropagation();
    if (onQRClick) onQRClick(table);
  };

  const handlePaymentComplete = (e) => {
    e.stopPropagation();
    if (onPaymentComplete) onPaymentComplete(table);
  };

  return (
    <div
      className={`table-card ${status}`}
      onClick={onClick ? () => onClick(table) : undefined}
      style={{ cursor: onClick ? 'pointer' : 'default' }}
    >
      {/* Table number */}
      <div className="table-card-num">
        {table.tableNumber || table.table_number}번
      </div>
      <div className="table-card-label">테이블</div>

      {/* Status indicator */}
      <div className="table-card-status">
        <span className={`pulse-dot ${config.dotClass}`} />
        <span style={{ color: config.textColor }}>{config.label}</span>
      </div>

      {/* Elapsed time for occupied */}
      {status === 'occupied' && elapsed && (
        <div style={{ fontSize: '0.75rem', color: 'var(--text-tertiary)', marginTop: 4, display: 'flex', alignItems: 'center', gap: 4 }}>
          <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="10"/>
            <polyline points="12 6 12 12 16 14"/>
          </svg>
          {elapsed}
        </div>
      )}

      {/* Current amount */}
      {(status === 'occupied' || status === 'payment_pending') && table.currentAmount != null && (
        <div className="table-card-amount">
          {formatWon(table.currentAmount || table.current_amount)}
        </div>
      )}

      {/* Payment done checkmark */}
      {status === 'payment_done' && (
        <div style={{ marginTop: 6, color: 'var(--success)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
            <polyline points="20 6 9 17 4 12"/>
          </svg>
        </div>
      )}

      {/* Action buttons */}
      {(onQRClick || onReset || onDelete || onPaymentComplete) && (
        <div className="table-card-actions">
          {onQRClick && (
            <button className="btn btn-sm btn-outline" onClick={handleQR} title="QR 코드 보기">
              QR
            </button>
          )}
          {onPaymentComplete && (status === 'occupied' || status === 'payment_pending') && (
            <button className="btn btn-sm btn-success" onClick={handlePaymentComplete} title="결제 완료 처리">
              결제완료
            </button>
          )}
          {onReset && status !== 'empty' && (
            <button className="btn btn-sm btn-warning" onClick={handleReset} title="상태 초기화">
              초기화
            </button>
          )}
          {onDelete && (
            <button className="btn btn-sm btn-danger" onClick={handleDelete} title="삭제">
              삭제
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default TableCard;
